<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="sale_messenger_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ sale_messenger_list.indexOf(props.item)+1 }}</td>
        <td>{{ props.item.order_code }}</td>
        <td>{{ props.item.rider_name }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.addon ? (parseFloat( props.item.addon).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.transport ? (parseFloat( props.item.transport).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.extra_time ? (parseFloat( props.item.extra_time).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.promotion ? (parseFloat( props.item.promotion).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.summary ? (parseFloat( props.item.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
      </template>
      <template slot="footer" style="border:none;">
        <td colspan="3" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td
          class="text-xs-right"
        >{{sale_messenger_summary.addon ? (parseFloat(sale_messenger_summary.addon).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{sale_messenger_summary.transport ? (parseFloat(sale_messenger_summary.transport).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{sale_messenger_summary.extra_time ? (parseFloat(sale_messenger_summary.extra_time).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{sale_messenger_summary.promotion ? (parseFloat(sale_messenger_summary.promotion).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{sale_messenger_summary.summary ? (parseFloat(sale_messenger_summary.summary).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Order ID", value: "order_id", sortable: false },
        { text: "Rider", value: "rider", sortable: false },
        { text: "Add on", value: "add_on", sortable: false, align: "center" },
        {
          text: "Transport",
          value: "transport",
          sortable: false,
          align: "center"
        },
        {
          text: "Extra time",
          value: "extra_time",
          sortable: false,
          align: "center"
        },
        {
          text: "Promotion",
          value: "promotion",
          sortable: false,
          align: "center"
        },
        {
          text: "Revenue",
          value: "total_revenue",
          sortable: false,
          align: "center"
        }
      ],
      column_items: [
        {
          text: "Revenue",
          value: "summary",
          sortable: false,
          align: "center"
        },
        { text: "Rider", value: "rider_name", sortable: false }
      ],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false
    };
  },
  watch: {
    sale_messenger_list() {
      if (this.isSort == false) {
        this.asc_desc = "asc";
        this.sort_column = "no_default";
      }
    }
  },
  computed: {
    ...mapState({
      sale_messenger_list: state =>
        state.fetchSaleMessengerReport.sale_messenger_list,
      sale_messenger_summary: state =>
        state.fetchSaleMessengerReport.sale_messenger_summary
    })
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.sale_messenger_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("fetchSaleMessengerReport/getExportReportForm");
      this.$store.commit("fetchSaleMessengerReport/getExportSummary");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  }
};
</script>

<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>